<template>
  <main class="image-grid">
    <img
      v-for="image in images"
      :src="image.thumb"
      :class="{ 'selected': selected && selected.uuid === image.uuid }"
      @click="clickedImage(image)"
      :data-cy="`photo-${image.uuid}`" />
  </main>
</template>

<script>
export default {
  name: "image-grid",
  props: {
    selected: Object,
    images: Array
  },
  methods: {
    clickedImage(image) {
      this.$emit('updated:selected', image);
    }
  }
}
</script>

<style scoped>
  .image-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  img {
    cursor: pointer;
    width: 65px;
    height: 65px;
  }

  img.selected {
    border: 2px solid #128ff9;
  }
</style>
